import React from 'react';
import styles from './SectionContentsBodyHeader.module.scss';
import {Col, Row} from 'reactstrap';

function SectionContentsBodyHeader({title, description, action, label}) {
  return (
    <div className={styles['header']}>
      <div className={styles['header--title']}>
        <Row noGutters>
          <Col>
            {!!label && (
              <p className={styles['header--title--label']}>{label}</p>
            )}
            <h2>{title}</h2>
          </Col>
          {!!action && (
            <Col className="col-auto d-flex align-items-center">{action}</Col>
          )}
        </Row>
        {!!description && <h5>{description}</h5>}
      </div>
    </div>
  );
}

export default SectionContentsBodyHeader;
